import { useEffect, useRef } from "react";

/**
 * Fades/slides elements marked with [data-reveal] into view as they are scrolled to.
 * Returns a ref to attach to the section that contains them.
 * Degrades to "everything visible" without IntersectionObserver or with reduced motion.
 */
const useReveal = () => {
    const rootRef = useRef(null);

    useEffect(() => {
        const root = rootRef.current;
        if (!root) return;

        const items = root.querySelectorAll("[data-reveal]");
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (reduceMotion || typeof IntersectionObserver === "undefined") {
            items.forEach((el) => el.classList.add("sf-revealed"));
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add("sf-revealed");
                    observer.unobserve(entry.target);
                });
            },
            { rootMargin: "0px 0px -6% 0px", threshold: 0.08 }
        );

        items.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    return rootRef;
};

export default useReveal;
